<!-- TEMPLATE -->
<template>
    <div :class='contactsListClass'>
      <div class='row'>
        <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
          <dean-section-title content='true'>
            <span slot='title'>
              <span class='avenir-heavy'>Contacten</span>
            </span>
            <dean-section-title-item
              v-if="!showArchive"
              :icon='archiveIcon'
              :content="true"
              @click.native="sectionRoute('customers.contacts.list.status', {status: 'verwijderd'})"
            >
              archief
            </dean-section-title-item>
            <dean-section-title-item
              v-else
              :icon='returnIcon'
              :content="true"
              @click.native="sectionRoute('customers.contacts.list')"
            >
              Terug naar actief
            </dean-section-title-item>
            <dean-section-title-item
              v-if="canCreateCustomerContact()"
              :icon='plusIcon'
              :content="true"
              @click.native="sectionRoute('customer.contact.add')"
            >
              Nieuw
            </dean-section-title-item>
          </dean-section-title>

          <dean-table
            :data='contactsData'
            :columns='columns'
            :hover="true"
            @column-click='columnClick'
            @cell-click="cellClick"
          >
          </dean-table>

          <dean-pagination
            :current-page='contactsMetaData.pageNumber'
            :total-items='contactsMetaData.totalResults'
            :items-per-page='contactsMetaData.itemsPerPage'
            :select-items-per-page='selectItemsPerPage'
            :visible-pages='contactsMetaData.visiblePages'
            @page-changed='paginationChanged'
            @items-per-page='itemsPerPageChanged'
          >
          </dean-pagination>
        </div>
      </div>
    </div>
</template>

<script lang='ts'>
  // VUE
  import {Component} from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';
  import sideMenuCustomerMixin from '@/mixins/sideMenuCustomerMixin';


  import {
    archiveIcon,
    deanIcon,
    deanInputSelect,
    deanPagination,
    deanSearchField,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    invoicesIcon,
    plusIcon,
    returnIcon,
    summeryIcon,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuCustomerMixin) {

    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public archiveIcon: object = archiveIcon;
    public returnIcon: object = returnIcon;
    public data: object[] = [];
    public showArchive: boolean = false;

    // COMPUTED
    get contactsListClass() {
      let value = 'address-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get contactsMetaData() {
      return this.pageMeta;
    }

    get contactsData() {
      return this.data;
    }

    public meta: object = {};

    public columns: any = {
      name: {
        content: 'naam',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      receivesInvoices: {
        content: 'ontvangt facturen',
        align: 'left',
        sort: true,
        dql: 'invoices',
      },
      receivesNotifications: {
        content: 'ontvangt berichten',
        align: 'left',
        sort: true,
        dql: 'notifications',
      },
    };

    public tableName(): string {
      return 'customer-contacts';
    }

    public cellClick(target: { cell: object, row: { id: string, personId: string }, column: string }) {
      this.$router.push({
        name: 'customer.contact.edit',
        params: {contactId: target.row.id, contextId: target.row.personId},
      });
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      const requestUrl: string = '/-/trade/api/customer.contacts.list';

      // TODO refactor meta and filter
      const requestData: any = {
        id: this.$route.params.pid,
        sort: data.sort,
        filter: (data.query ? `name=%${data.query}%` : ''),
        deleted: data.showArchive ? true : null,
        meta: {
          startIndex: ((data.pageNumber - 1) * data.itemsPerPage), // TODO move calc somewhere else ?
          numberOfItems: data.itemsPerPage,
        },
      };

      axios.post(requestUrl, requestData)
        .then((response) => {
          this.data = response.data.data.map((contact: any) => {
            return {
              id: contact.id,
              customerId: this.$route.params.pid,
              name: contact.name,
              receivesInvoices: contact.receivesInvoices ? 'Ja' : 'Nee',
              receivesNotifications: contact.receivesNotifications ? 'Ja' : 'Nee',
            };
          });

          this.updateMeta(response.data.meta);
        }).then(
        // Resolve promise response/error
        (response) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
        (error) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public canCreateCustomerContact(): boolean {
      if (this.$store.getters.getUser.privileges.includes('create-customer-contact')) {
        return true;
      }

      return false;
    }

    public created() {
      this.showArchive = this.$router.currentRoute.params.status === 'verwijderd';

      const data: any = this.pageMeta;
      data.showArchive = this.showArchive;

      this.setDefaultSort('name');
      this.loadList(data);
      this.buildSideMenuCustomer(this.$route.params.pid);
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>

